import React from 'react';
import './pageLoading.less';

class PageLoadingComponent extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			display: false,
			css: ''
		};
	}

	componentDidMount() {

	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.keyTime !== prevProps.keyTime) {
			if (this.props.display) {
				this.show();
			}else{
				this.hide();
			}
		}
	}

	show(){
		this.setState({
			display: true,
		}, () => {
			clearTimeout(this.hideLoop);
			clearTimeout(this.showLoop);
			this.showLoop = setTimeout(() => {
				this.setState({
					css: ''
				});
			}, 100);
		});
	}

	hide() {
		this.setState({
			css: 'hide'
		}, () => {
			clearTimeout(this.hideLoop);
			clearTimeout(this.showLoop);
			this.hideLoop = setTimeout(() => {
				this.setState({
					display: false
				});
			}, 550);
		});
	}

	componentWillUnmount() {
		clearTimeout(this.loop);
	}

	render() {
		return (
			this.state.display ? <div id="loading-page-animate-component-wrapper" className={this.state.css}>
				<div className="loading-icon"/>
			</div> : ''
		);
	}
}


export default PageLoadingComponent;



// WEBPACK FOOTER //
// ./src/components/public/loading/pageLoadingComponent.js